/* Auto Generated */

export enum HeroBackgroundColor {
	grey,
	magenta,
	blue,
}
